// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

//import Vconsole from 'Vconsole';
//const vConsole = new Vconsole();
//Vue.use(vConsole)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import HappyScroll from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css'
import './mixin'
import VideoPlayer from 'vue-video-player'
import '../static/jquery.js';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
import '@/assets/css/css.css'
import '@/assets/css/reset.css'
import Login from '@/components/login';
import Head from '@/components/head';
import Foot from '@/components/foot';
import Navbar from '@/components/navbar';
import showWordInfo from '@/components/showWordInfo';
import ShowScroe from '@/components/showScroe';
import ShowTeacherFeedback from '@/components/showTeacherFeedback';
import AiAsq from '@/components/ai-ASQ';
import Airarsdlrl from '@/components/ai-RARSDLRL';
import Aidlrl from '@/components/ai-DLRL';
import AiSwt from '@/components/ai-swt';
import AiWe from '@/components/ai-we';
import AiWfd from '@/components/ai-wfd';
import AiDesc from '@/components/ai_desc';
import Message from '@/components/message';
Vue.component('Login', Login)
Vue.component('Head', Head)
Vue.component('Foot', Foot)
Vue.component('Navbar', Navbar)
Vue.component('showWordInfo', showWordInfo)
Vue.component('ShowScroe', ShowScroe)
Vue.component('ShowTeacherFeedback', ShowTeacherFeedback)
Vue.component('AiAsq', AiAsq)
Vue.component('AiRARSDLRL', Airarsdlrl)
Vue.component('AiDLRL', Aidlrl)
Vue.component('AiSWT', AiSwt)
Vue.component('AiWE', AiWe)
Vue.component('AiWFD', AiWfd)
Vue.component('AiDesc', AiDesc)
Vue.component('Message', Message)

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import ch from './assets/languages/ch'
import en from './assets/languages/en'
if (!localStorage.getItem("lang")&&navigator.language.startsWith('ch')) {
  localStorage.setItem("lang","ch");
}
const i18n = new VueI18n({
	locale: !localStorage.getItem("lang") ?
		"ch" : localStorage.getItem("lang"),
	messages: {
		'ch': ch, // 本地资源文件，配2个语言，中文&英文，src下根据个人情况放置
		'en': en
	},
	silentTranslationWarn: true
});

if(localStorage.getItem('token')) {
	store.commit("getUserinfo");
	store.commit("changeLoginFlag", true);
}else{
	store.commit("changeLogin", true);
	store.commit("changeLoginFlag", false);
}


router.beforeEach((to, from, next) => {
	if(to.fullPath == '/register' || to.fullPath == '/yinsi'){
		next()
	}
	if(!localStorage.getItem('token')) {
		if(to.name == 'index') {
			next()
		} else {
			store.commit("changeLogin", true);
		}
	} else {
		next()
	}
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
})

// import waicTabs from '@/components/tabs'
// Vue.component('waic-tabs', waicTabs)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)
Vue.use(HappyScroll)
Vue.prototype.i18n = i18n;

Vue.directive('Int', {
	bind: function(el, binding, vnode) {
		let input = el.getElementsByTagName('input')[0]
		input.onkeyup = function() {
			if(input.value.length === 1) {
				input.value = input.value.replace(/[^0-9]/g, '')
			} else {
				input.value = input.value.replace(/[^\d]/g, '')
			}
		}
		input.onblur = function() {
			if(input.value.length === 1) {
				input.value = input.value.replace(/[^0-9]/g, '')
			} else {
				input.value = input.value.replace(/[^\d]/g, '')
			}
		}
	}
})

/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	store,
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js